var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVehicleIconBook2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.40625 0.0990181H20.5958C20.8433 0.0990181 21.0438 0.299538 21.0438 0.546995V20.4036C21.0438 20.651 20.8433 20.8516 20.5958 20.8516H5.40625V0.0990181Z",
    fill: "#313748"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31801 0.100567H6.10748V21.6968H3.3262C2.46531 21.6968 1.65586 22.4012 1.65586 23.3672H0.8125V2.62323C0.8125 1.23948 1.93426 0.109138 3.31801 0.100567Z",
    fill: "#38907A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7168 21.2769C20.2357 22.6718 20.2372 24.069 20.7168 25.4688H3.33068C2.17278 25.4688 1.23438 24.5303 1.23438 23.3728C1.23438 22.2153 2.17278 21.2769 3.33068 21.2769H20.7168Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10938 20.8516V21.6953H20.8726C21.1085 21.6953 21.2941 21.5097 21.2941 21.2735C21.2941 21.0458 21.1085 20.8516 20.8726 20.8516H6.10938Z",
    fill: "#3D4359"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8726 25.0473H6.10938V25.8906H20.8726C21.1085 25.8906 21.2941 25.6965 21.2941 25.4688C21.2941 25.2414 21.1085 25.0473 20.8726 25.0473Z",
    fill: "#3D4359"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.32993 20.8543H6.10748V21.698H3.32993C2.40681 21.698 1.65623 22.4493 1.65623 23.3728C1.65623 24.2956 2.40681 25.0469 3.32993 25.0469H6.10748V25.8906H3.32993C1.94208 25.8906 0.8125 24.7611 0.8125 23.3721C0.8125 21.9839 1.94208 20.8543 3.32993 20.8543Z",
    fill: "#46AD96"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.583 0.0980043V8.28125L13.3306 6.02881L11.0781 8.28125V0.0980043H15.583Z",
    fill: "#F03C54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleIconBook2);
export default __webpack_public_path__ + "static/media/Vehicle_Icon_book2.084934622a70e2843b5821a1417d7345.svg";
export { ForwardRef as ReactComponent };